const materialsFields = [
  {
    name: "course_id",
    label: "Course Title",
    type: "select",
    placeholder: "Course Title",
  },
  {
    name: "uploaded_by",
    label: "Uploaded By User",
    type: "select",
    placeholder: "Uploaded By",
    value: "name",
  },
  {
    name: "title",
    label: "Material Title",
    type: "text",
    placeholder: "type material title",
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    placeholder: "Material Description",
  },
  {
    name: "media_type",
    label: "File Type",
    type: "text",
  },
  {
    name: "mime_type",
    label: "File Mime Type",
    type: "text",
  },
  {
    name: "size",
    label: "File Size",
    type: "text",
  },
];

export default materialsFields;
